import React from 'react';
import { Flex } from '@chakra-ui/react';

import { TTemplate } from '@/helpers/createTemplate';
import { CheckboxRunnerBoxed } from '../../Action/styles/Action.styles';

export const template = (
  isChecked: boolean,
  isDisabled: boolean,
  selectAllPositions: () => void,
  runnerNumber: number | undefined
): TTemplate => ({
  wrapper: (
    <Flex alignItems="center" id="boxedButton-Container" marginLeft="2" />
  ),
  button: (
    <CheckboxRunnerBoxed
      data-testid={
        runnerNumber !== undefined
          ? `runnerCheckbox-${runnerNumber}`
          : 'fieldCheckbox'
      }
      area-selected={isChecked}
      data-cy={
        runnerNumber !== undefined
          ? `runnerCheckbox-${runnerNumber}`
          : 'fieldCheckbox'
      }
      isChecked={isChecked}
      isDisabled={isDisabled}
      onChange={selectAllPositions}
      variant="unstyled"
    />
  ),
});

export default template;
